import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUserHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUserHeart"><Path d="M12 20.5H4.5V19.5C4.5 15.3579 7.85786 12 12 12" stroke="currentColor"/><Circle cx="12" cy="7.5" r="4.5" stroke="currentColor"/><Path d="M21.5 16.5665C21.5 19.2998 17.75 20.8 17.75 20.8C17.75 20.8 14 19.2998 14 16.5665C14 14.518 16.0157 13.2984 17.75 14.4366C19.4843 13.2984 21.5 14.518 21.5 16.5665Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUserHeart;
